import { React } from 'react';

const Footer = () => {
    return (
        <div className='footer-pin hide-body'> 
                <footer className='center'>
                    <div>
                      <small>Ⓒ 2023 All Rights Reserved to Gian-Gabriel Garcia</small><div></div>
                      <small><a className="privacy-policy" href="/privacy-policy">Privacy Policy</a></small>
                    </div>
                </footer>
        </div>
    )
}

export default Footer; 